import { Dialog } from 'primereact/dialog'
import React from 'react'

const OrdersModel = ({ data, visible , setVisible }) => {

    const rowStyle = { display: "flex", padding: "6px 0", borderBottom: "1px solid #eee" };
    const labelStyle = { width: "180px", fontWeight: 600 };

  return (
    <Dialog header={`Order Details - ${data?.orderNumber || data?.orderId}`} closeOnEscape={true} modal={true} dismissableMask={true} visible={visible} onHide={() => setVisible(false)} style={{ width: "50vw" }} breakpoints={{ "960px": "75vw", "641px": "95vw" }} >
      <div>
        <div className='row border shadow-none bg-white py-2 px-3' style={{borderRadius: '10px'}}>
          <div className="col-md-6 mb-1">
            <div className='text-muted small fw-bold text-uppercase'>Order ID</div>
            <div className='mb-1'>{data?.orderId ?? "-"}</div>
          </div>
          <div className="col-md-6 mb-1">
            <div className='text-muted small fw-bold text-uppercase'>Order Number</div>
            <div className='mb-1'>{data?.orderNumber ?? "-"}</div>
          </div>
          <hr/>
          <div className="col-md-6 mb-1">
            <div className='text-muted small fw-bold text-uppercase'>User ID</div>
            <div className='mb-1'>{data?.userId ?? "-"}</div>
          </div>
          <div className="col-md-6 mb-1">
            <div className='text-muted small fw-bold text-uppercase'>User Name</div>
            <div className='mb-1'>{data?.userName ?? "-"}</div>
          </div>
          <hr/>
          <div className="col-md-6 mb-1">
            <div className='text-muted small fw-bold text-uppercase'>User Email</div>
            <div className='mb-1'>{data?.userEmail ?? "-"}</div>
          </div>
          <div className="col-md-6 mb-1">
            <div className='text-muted small fw-bold text-uppercase'>User Mobile</div>
            <div className='mb-1'>{data?.userMobileNumber ?? "-"}</div>
          </div>
          <hr/>
          <div className="col-md-6 mb-1">
            <div className='text-muted small fw-bold text-uppercase'>Sub Total</div>
            <div className='mb-1'>{data?.subTotal ?? "-"}</div>
          </div>
          <div className="col-md-6 mb-1">
            <div className='text-muted small fw-bold text-uppercase'>Discount Amount</div>
            <div className='mb-1'>{data?.discountAmount ?? "-"}</div>
          </div>
          <hr/>
          <div className="col-md-6 mb-1">
            <div className='text-muted small fw-bold text-uppercase'>Tax Amount</div>
            <div className='mb-1'>{data?.taxAmount ?? "-"}</div>
          </div>
          <div className="col-md-6 mb-1">
            <div className='text-muted small fw-bold text-uppercase'>Grand Total</div>
            <div className='mb-1'>{data?.grandTotal ?? "-"}</div>
          </div>
          <hr/>
          <div className="col-md-6 mb-1">
            <div className='text-muted small fw-bold text-uppercase'>Payment Status</div>
            <div className={`badge mb-1 ${data?.paymentStatus === 'success' && 'bg-success' || data?.paymentStatus === 'failed' && 'bg-danger' || data?.paymentStatus === 'pending' && 'bg-info'} `}>{data?.paymentStatus ?? "-"}</div>
          </div>
          <div className="col-md-6 mb-1">
            <div className='text-muted small fw-bold text-uppercase'>Payment Method</div>
            <div className='mb-1 text-capitalize'>{data?.paymentMethod ?? "-"}</div>
          </div>
          <hr/>
          <div className="col-md-6 mb-1">
            <div className='text-muted small fw-bold text-uppercase'>Failure Reason</div>
            <div className='mb-1'>{data?.failureReason ?? "-"}</div>
          </div>
          <div className="col-md-6 mb-1">
            <div className='text-muted small fw-bold text-uppercase'>Razorpay Order ID</div>
            <div className='mb-1'>{data?.razorpayOrderId ?? "-"}</div>
          </div>
          <hr/>
          <div className="col-md-6 mb-1">
            <div className='text-muted small fw-bold text-uppercase'>Quiz ID</div>
            <div className='mb-1'>{data?.quizId ?? "-"}</div>
          </div>
          <div className="col-md-6 mb-1">
            <div className='text-muted small fw-bold text-uppercase'>Created At</div>
            <div className='mb-1'>{data?.createdAt ? new Date(data.createdAt).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: true, }) : "-"} </div>
          </div>
        </div>

        <div style={{ marginTop: "12px" }}>
          <div style={{ fontWeight: 900, marginBottom: "6px" }}>Courses</div>
          {data?.courses.map((item) => (
            <li className="list-group-item mb-2 row border shadow-none bg-white py-3 px-3 mt-1" style={{ borderRadius: "10px", }} >
              <div className="d-flex align-items-center" style={{ justifyContent: 'space-between' }}>
                <div className="d-flex align-items-center">
                  <div className="me-3" style={{ flexShrink: 0, width: '60px', height: '40px' }}>
                    <img className="me-3" src={`${process.env.REACT_APP_BASE_URL}/${item.courseImage}`} onError={(e) => { e.target.src = "/img/placeholder-image.jpg" }} alt="" style={{ width: '100%', height: '100%', borderRadius: '10px', objectFit: 'cover' }} />
                  </div>
                  <div>
                    <label> <b> {item.courseName} </b> </label>
                    <br/>
                    <label> <b> ₹{item.price} </b> </label>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </div>
      </div>
    </Dialog>
  )
}

export default OrdersModel
